import type { JSX } from 'react'

/**
 * Keyboard accessibility helper: visually hidden link at the top of the layout.
 * Becomes visible on focus, allowing keyboard users to skip past the nav.
 */
export function SkipLink(): JSX.Element {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:p-2 focus:bg-[#16273F] focus:text-white focus:rounded focus:z-[60]"
    >
      Skip to main content
    </a>
  )
}

export default SkipLink
